import { render, staticRenderFns } from "./invitadoForm.vue?vue&type=template&id=c059ec5c&class=app-bg-login&"
import script from "./invitadoForm.vue?vue&type=script&lang=ts&"
export * from "./invitadoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports